class TC_PricingPage {
    constructor () {
        if ($('#plans_container').length) {
            this.initEvents();
        }
    }

    initEvents () {
        this.preventDefaultInBuyButtons();

        jQuery(document).ready(function($) {
            let detectedPlan = false;
            let foundedPlanID = window.location.search.replace('?', '').split('&').filter(part => part.indexOf('plan_id=') > -1);

            if (foundedPlanID && foundedPlanID.length) {
                detectedPlan = foundedPlanID[0].replace('plan_id=', '');
            }

            if (detectedPlan) {
                let items = $('input[name="plan-id"]');
                let foundedItem = false;
                
                for (let i = 0; i < items.length; i++) {
                    if (items.eq(i).val() === detectedPlan) {
                        foundedItem = items.eq(i);
                        break;
                    }
                }

                if (foundedItem) {
                    setTimeout(() => {
                        foundedItem.parent().find('.btn-buy').trigger('click');
                    }, 1500);
                }
            }
        });
    }

    preventDefaultInBuyButtons () {
        $('#plans_container').find('.btn-buy').on('click', function(e) {
            e.preventDefault();
        });

        $('#plans_container').find('.btn-buy-additional').on('click', function(e) {
            e.preventDefault();
        });
    }
}
